var BASWebServices;
(function (BASWebServices) {
    var SessionIDController = (function () {
        function SessionIDController($scope, $http) {
            this.$scope = $scope;
            $scope.sidc = this;
            var _scope = $scope;
            var pathToSession = BASWebServices.ConfigService.GET_SESSION_ID_URL();
            var sessionIdPromise = $http({
                method: 'GET',
                url: pathToSession
            });
            sessionIdPromise.then(function successCallback(response) {
                _scope.sessionId = response.data;
                _scope.sessionId = _scope.sessionId.trim();
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
        }
        return SessionIDController;
    }());
    BASWebServices.SessionIDController = SessionIDController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=SessionIDController.js.map